<template>
  <div class="A06_rygs">
    <div class="title">
      <div class="txtStyle">人员公示</div>
      <div class="bj"></div>
    </div>
    <div class="content1">
      <a
        href="https://gs.sac.net.cn/pages/registration/sac-publicity-finish.html?aoiId=199105&ptiId=5"
        target="_blank"
      >
        <div class="card">
          <div class="cardImg" id="imgA"></div>
          <div class="cardName">证券投资咨询（投资顾问）从业人员公示</div>
        </div>
      </a>
      <a
        href="https://gs.sac.net.cn/pages/registration/sac-publicity-finish.html?aoiId=199105&ptiId=0"
        target="_blank"
      >
        <div class="card">
          <div class="cardImg" id="imgB"></div>
          <div class="cardName">证券投资咨询（一般证券业务）从业人员公示</div>
        </div>
      </a>
      <!-- <a
        href="https://exam.sac.net.cn/pages/registration/sac-publicity-finish.html?aoiId=199105&ptiId=5"
        target="_blank"
      >
        <div class="card">
          <div class="cardImg" id="imgA"></div>
          <div class="cardName">证券投资咨询（投资顾问）从业人员公示</div>
        </div>
      </a>
      <a
        href="https://exam.sac.net.cn/pages/registration/sac-publicity-finish.html?aoiId=199105&ptiId=0"
        target="_blank"
      >
        <div class="card">
          <div class="cardImg" id="imgB"></div>
          <div class="cardName">证券投资咨询（一般证券业务）从业人员公示</div>
        </div>
      </a> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "A06_rygs",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.A06_rygs {
  width: 1080px;
  margin-left: 278px;
  min-height: 940px;
}
.title {
  position: relative;
  width: 710px;
  height: 56px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  font-size: 40px;
  text-align: center;
  line-height: 56px;
  margin-top: 20px;
  margin: 0 auto;
  margin-bottom: 40px;
  /* margin: 20px 0px 20px 287px; */
}
.txtStyle {
  line-height: 56px;
}
.bj {
  position: absolute;
  top: 20px;
  /* left: 598px; */
  width: 778px;
  height: 16px;
  background: url("../../common/images/investCenter/textBj.png") no-repeat;
}
.content1 {
  width: 100%;
  display: flex;
}
.card {
  width: 520px;
  height: 420px;
  border: 1px solid #e9e9e9;
  background-color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 8px;
  margin-right: 40px;
}
.cardImg {
  width: 490px;
  height: 327px;
  margin: 10px auto 0;
  background-size: 100% 100%;
}
#imgA {
  background: url("../../common/images/about/A06_rygs/tzgw.png") no-repeat;
}
#imgB {
  background: url("../../common/images/about/A06_rygs/ybzqyw.png") no-repeat;
}
.cardName {
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 73px;
  color: #333333;
  opacity: 1;
}
.card:hover .cardName {
  color: #e7413b;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutS/A06_rygs.vue